import { Link } from "react-router-dom";
import { categories, hotTags } from "../../mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100 mt-auto">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4" aria-label="策驰漫画网首页">
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-primary-300">策驰漫画网</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              分类书库齐全、人气排行与编辑精选推荐的漫画平台。从少年热血到恋爱日常，一站式发现你爱看的好漫画，书库持续扩充中。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" rel="nofollow" aria-label="微博" className="w-9 h-9 rounded-full bg-background-100/10 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-weibo-line"></i></a>
              <a href="#" rel="nofollow" aria-label="哔哩哔哩" className="w-9 h-9 rounded-full bg-background-100/10 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-bilibili-line"></i></a>
              <a href="#" rel="nofollow" aria-label="抖音" className="w-9 h-9 rounded-full bg-background-100/10 flex items-center justify-center text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"><i className="ri-tiktok-line"></i></a>
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h3 className="font-label font-bold text-background-50 mb-4">栏目导航</h3>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li><Link to="/" className="hover:text-accent-400 transition-colors">网站首页</Link></li>
              <li><Link to="/fenlei" className="hover:text-accent-400 transition-colors">漫画库分类</Link></li>
              <li><Link to="/paihang" className="hover:text-accent-400 transition-colors">人气排行榜</Link></li>
              <li><Link to="/guanyu" className="hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><Link to="/lianxi" className="hover:text-accent-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          {/* 分类 */}
          <div>
            <h3 className="font-label font-bold text-background-50 mb-4">热门分类</h3>
            <ul className="space-y-2.5 text-sm text-background-300">
              {categories.slice(0, 6).map((c) => (
                <li key={c.name}>
                  <Link to={`/fenlei?cat=${encodeURIComponent(c.name)}`} className="hover:text-accent-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 标签 */}
          <div>
            <h3 className="font-label font-bold text-background-50 mb-4">热门标签</h3>
            <div className="flex flex-wrap gap-2">
              {hotTags.slice(0, 12).map((t) => (
                <Link
                  key={t}
                  to={`/fenlei?tag=${encodeURIComponent(t)}`}
                  className="px-3 py-1.5 rounded-full text-xs bg-background-100/10 text-background-200 hover:bg-accent-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  #{t}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {new Date().getFullYear()} 策驰漫画网 · 内容仅供学习交流，请支持正版漫画</p>
          <p className="flex items-center gap-1.5"><i className="ri-route-fill text-primary-400"></i> 本站为演示网站，不提供真实下载服务</p>
        </div>
      </div>
    </footer>
  );
}